// extracted by mini-css-extract-plugin
export default {"sectionMethodology":"Methodology__sectionMethodology___cG2H2","methodology":"Methodology__methodology___Lt0dL","step":"Methodology__step___HdY7u"};